// extracted by mini-css-extract-plugin
module.exports = {"page_control":"index--page_control--1WSps","page_control__item":"index--page_control__item--mAN3Z","page_control__item--selected":"index--page_control__item--selected--4uqk7"};